import Accordion from './Accordion';
import SwitchAccordion from './SwitchAccordion';
import PaletteAccordion from './PaletteAccordion';
import PaletteAccordionList from './PaletteAccordionList';
export default Accordion;
export { SwitchAccordion, PaletteAccordion, PaletteAccordionList };